export const EMPTY_STRING = "";

export const noop = () => undefined;

export const defaultValue = <T, U>(value: T, fallback: U) =>
	value ?? fallback;

export function isEmpty(value: string | null | undefined | number) {
	return value === undefined || value === null || value === "";
}